import axios from "axios";
import Config from "../config/env.config.json";
const instance = axios.create({
  baseURL: Config.STRAPI_ADDRESS,
  timeout: 30000,
});

export { instance as default };
